import {ChannelIdealRunRate} from "./ChannelIdealRunRate";
import {AssetTypeOption} from "./AssetTypeOption";
import { Config } from "./Config";
import {AssetTypeState} from "./AssetTypeState";
import {CommonAsset} from "./CommonAsset";
import {LineSegment} from "./LineSegment";
import {DataContract} from "./DataContract";
import {DataContractDriverFieldValueDto} from "./DataContractDriverFieldValueDto";
import {AssetState} from "../domain/AssetState";

export class Asset extends CommonAsset {
  activeProperties?: Array<string>;
  assetTypeTemplateTag?:string;
  assetTypeState?: AssetTypeState;
  versionId?: number;
  versionName?: string;
  assetTypeOptionList?: Array<AssetTypeOption> ;
  isCountable?: boolean;
  isCountableForRejects?: boolean;
  heatMapEnabledFor?: string;
  sensorStatusEnabledFor?: string;
  platenCount?: number;
  chamberCount?: number;
  channelIdealRunRateList?: Array<ChannelIdealRunRate>;
  assetConfigList?:  Array<Config>;
  assetTypeTags?:  Array<string>;
  hmiVersion?: string;
  assetTier?: string;
  assetCategory?: string;
  gatewayId?: number;
  gatewayName?: string;
  transformerConfigs?: string;
  disconnectDate?: number;
  firstIngestionDate? : number;
  streamName?: string;
  lineSegments?:  Array<LineSegment>;
  assetWidgetConfigs?: string;
  dataContract?: DataContract;
  dataContractDriverFieldValueDtos?: Array<DataContractDriverFieldValueDto>;
  ipAddress?: string;
  state?: string;
  stateColor?: string;
  assetStateList?: Array<AssetState>;
  activationCode?: string;
  activationId?: string;

  static setAssetTypeOptions(assetInput : Asset, ids : Array<number>) {
    ids.forEach((id) => {
      assetInput.assetTypeOptionList  =  [];
      let option = new AssetTypeOption();
      option.id = id;
      assetInput.assetTypeOptionList.push(option);
    });
  }

  static setAssetConfigs(assetInput : Asset, configs : Array<Config>) {
    configs.forEach((config) => {
      assetInput.assetConfigList = [];
      let c = new Config();
      c.configId = config.configId;
      c.name = config.name;
      if (c.value != null) {
        assetInput.assetConfigList.push(c);
      }
    });
  }


}
